import vkBridge from "@vkontakte/vk-bridge";

const listeners = new Set();
let bridgeReferralToken = "";
let isListenerReady = false;

// initReferralLaunchListener слушает hash родительского VK URL до инициализации приложения.
export function initReferralLaunchListener() {
    if (isListenerReady) {
        return;
    }

    isListenerReady = true;
    vkBridge.subscribe(event => {
        if (!isVkLocationEvent(event?.detail?.type)) {
            return;
        }

        setBridgeReferralToken(parseReferralTokenFromString(event?.detail?.data?.location));
    });
}

// onReferralTokenChanged подписывает код на позднюю доставку токена из VK Bridge.
export function onReferralTokenChanged(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

// getReferralTokenFromLocation достаёт токен из VK Bridge, query или hash iframe URL.
export function getReferralTokenFromLocation(location = window.location) {
    return bridgeReferralToken || parseReferralTokenFromBrowserLocation(location);
}

// parseReferralTokenFromString разбирает токен из строки VK location или обычного URL.
export function parseReferralTokenFromString(value) {
    const raw = String(value || "").trim();
    if (!raw) {
        return "";
    }

    const directToken = readReferralTokenFromParams(raw);
    if (directToken) {
        return directToken;
    }

    try {
        const url = new URL(raw, window.location.origin);
        return readReferralTokenFromParams(url.search) || readReferralTokenFromParams(url.hash);
    } catch (err) {
        return readReferralTokenFromParams(raw);
    }
}

function setBridgeReferralToken(token) {
    if (!token || bridgeReferralToken === token) {
        return;
    }

    bridgeReferralToken = token;
    listeners.forEach(listener => listener(token));
}

function parseReferralTokenFromBrowserLocation(location) {
    return readReferralTokenFromParams(location.search) || readReferralTokenFromParams(location.hash);
}

function readReferralTokenFromParams(value) {
    const params = String(value || "").replace(/^[?#]/, "");
    if (!params) {
        return "";
    }

    const searchParams = new URLSearchParams(params);
    const directToken = searchParams.get("referral_token");
    if (directToken) {
        return directToken;
    }

    // createHashParamRouter хранит путь в #path=/route?referral_token=...
    return readReferralTokenFromPath(searchParams.get("path"));
}

function readReferralTokenFromPath(path) {
    const value = String(path || "");
    const queryIndex = value.indexOf("?");
    if (queryIndex < 0) {
        return "";
    }

    return new URLSearchParams(value.slice(queryIndex + 1)).get("referral_token") || "";
}

function isVkLocationEvent(type) {
    return type === "VKWebAppLocationChanged" || type === "VKWebAppChangeFragment";
}
